import React, { useEffect, useState } from 'react';
import { supabase } from './supabaseClient.js';
import { Link } from 'react-router-dom';

function EliteHeadsUp() {
  const [topCharacters, setTopCharacters] = useState([]);
  const [pair, setPair] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTopCharacters = async () => {
      const { data, error } = await supabase
        .from('characters')
        .select('*')
        .order('vs_votes', { ascending: false })
        .limit(250);

      if (error) {
        console.error('Error cargando top 100:', error);
      } else {
        setTopCharacters(data);
        pickRandomPair(data);
        setLoading(false);
      }
    };

    fetchTopCharacters();
  }, []);

  const pickRandomPair = (list) => {
    if (list.length < 2) return;

    const first = list[Math.floor(Math.random() * list.length)];
    let second;
    do {
      second = list[Math.floor(Math.random() * list.length)];
    } while (second.id === first.id);

    setPair([first, second]);
  };

  const voteFor = async (id) => {
    const { error } = await supabase.rpc('increment_vs_votes', { target_id: id });

    if (error) {
      console.error('Error al votar:', error);
    } else {
      pickRandomPair(topCharacters);
    }
  };

  return (
    <div style={{ textAlign: 'center', padding: '2rem' }}>
      <h1>👑 Elite Heads Up: Top 100 Face-Off</h1>
      <Link to="/" style={{ display: 'inline-block', marginBottom: '1.5rem', fontWeight: 'bold' }}>
        ← Back to Homepage
      </Link>

      {loading ? (
        <p>Loading elite characters...</p>
      ) : (
        <div style={{ display: 'flex', justifyContent: 'center', gap: '3rem', marginBottom: '2rem' }}>
          {pair.map((char) => (
            <div key={char.id}>
              <div onClick={() => voteFor(char.id)} style={{ cursor: 'pointer' }}>
                <img src={char.image} alt={char.name} width={280} height={280} style={{ borderRadius: '16px' }} />
              </div>

              <div style={{
                marginTop: '0.8rem',
                padding: '0.5rem 1.2rem',
                backgroundColor: '#fef7d6',
                border: '3px solid gold',
                borderRadius: '16px',
                fontWeight: 'bold',
                fontSize: '1.5rem',
                color: '#ff9800',
                display: 'inline-block'
              }}>
                {char.vs_votes ?? 0} VOTES
              </div>

              <p style={{ margin: '0.8rem 0 0.2rem', fontSize: '0.95rem' }}>
                <strong>UNIVERSE:</strong> {char.universo ?? '—'}<br />
                <strong>CREATED BY:</strong>{' '}
                <span
                  onClick={() => window.open(`/${char.creador_url}`, '_blank')}
                  style={{ textDecoration: 'none', color: '#007BFF', cursor: 'pointer' }}
                >
                  {char.creador_url}
                </span>
              </p>
            </div>
          ))}
        </div>
      )}

      <Link
        to="/"
        style={{
          display: 'inline-block',
          padding: '0.7rem 1.4rem',
          fontSize: '1rem',
          fontWeight: 'bold',
          backgroundColor: '#EEE',
          color: '#000',
          borderRadius: '12px',
          textDecoration: 'none',
          marginTop: '2rem',
          border: '1px solid #ccc'
        }}
      >
        ← Return to Main Heads Up
      </Link>
    </div>
  );
}

export default EliteHeadsUp;